import Sidebar from "../../../components/Sidebar";
import MentorProfile from "../../../components/profile/MentorProfile";

const BookAppointmentPage = () => {
  return (
    <Sidebar>
      <MentorProfile/>
    </Sidebar>
  );
};

export default BookAppointmentPage;
